<template>
  <!---------------------------------------------------------------------
    공통 : common
  ----------------------------------------------------------------------->
  <article class="common">
    <div class="scroll">
      <article class="contents">
        <!-- tab content -->

        <div class="breakdown">
          <strong class="total-count">
            {{ /*총 건수*/ $t("MCOM-0000079") }} : {{ RBF0409S40Response.totalCnt }}
            <i class="icon icon-import" @click="modalOpen" />
          </strong>

          <common-grid
            ref="commonGrid"
            :list="RBF0409S40Response.dataGrid"
            :total-line-cnt="RBF0409S40Response.totalCnt"
            :scroll-event="true"
            :tagType="'div'"
            :totalCss="['total-count', 'no-border']"
            :showTotalLineCnt="false"
            @reSearch="scrollEvent"
          >
            <template v-slot:list="data">
              <!-- 해제 -->
              <ul class="breakdown-list">
                <li>
                  <ul>
                    <li class="list-item">
                      <div class="item strong">
                        <div class="tit">{{ $t(`${data.row.brncoElctrFinacTranPtrnDstcd}_BO전자금융거래유형`) }}</div>
                        <div class="desc normal">{{ $t(`${data.row.acidntRprtRegiStusDstcd}_인터넷사고신고내역`) }}</div>
                      </div>
                      <div class="item etc">
                        <div class="tit">{{ $t("MACD-01-01-10") /*신고일*/ }}</div>
                        <div class="desc">{{ $getGlobalDateFmt(data.row.acidntRprtYmd) }}</div>
                      </div>
                      <div class="item etc">
                        <div class="tit">{{ $t("MHLP-03-01-01-04") /*해당 사용자 ID*/ }}</div>
                        <div class="desc">{{ $t($maskId(data.row.userIdnfr)) }}</div>
                      </div>
                      <div class="item etc">
                        <div class="tit">{{ $t("MACD-01-06-03") /*신고채널*/ }}</div>
                        <div class="desc">{{ $t(`${data.row.chnlDstcd}_채널구분코드`) }}</div>
                      </div>
                    </li>
                    <!--// 해제 end -->
                  </ul>
                </li>
              </ul>
            </template>
          </common-grid>
        </div>
      </article>
    </div>

    <!--// end -->

    <!-- modal -->
    <modal-pop :opened.sync="type" :modalHeader="true" :modalFooter="true" class="modal">
      <template #content>
        <div>
          {{
            $t("MACD-01-06-12") /*인터넷뱅킹을 비롯하여 모든 전자금융 사고신고 내역까지 조회하실 수
          있습니다.*/
          }}
        </div>
        <div>{{ /*10년 이내의 내역만 조회하실 수 있습니다*/ $t("MACD-01-06-05") }}</div>
        <div>
          {{
            /*신고사항의 해제는 영업점에서 본인확인 후에 가능하므로
          신분증(기업 고개의 경우 법인 관련 서류)을 지참하시고 영업점에
          방문하셔서 서면으로 신청하셔야 합니다.*/ $t("MACD-01-03-12")
          }}
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="type = !type">{{ $t("MPRS-01-01-07-16") /*확인*/ }}</button>
      </template>
    </modal-pop>
    <!-- end -->
  </article>
</template>
<style type="scss" scoped></style>
<script>
import CommonGrid from "@/components/page/common/CommonGrid";
// import ContentsHeader from "@/components/page/common/ContentsHeader.vue";
// import AcnoSelectBox from "@/components/page/common/AcnoSelectBox";
import { mapFields } from "vuex-map-fields";
//import AccountList from "@/components/page/customer/account.vue";
import { mapActions } from "vuex";

// const INQUERY_DST = "0"; //0 : 계좌, 1 : 인터넷

export default {
  name: "foreign",
  components: {
    // ContentsHeader,
    // AcnoSelectBox,
    //AccountList,
    CommonGrid,
  },
  computed: {
    ...mapFields("customer/suppStore", ["reportList", "acnoInfo"]),
    ...mapFields(["sessionInfo"]),
  },
  data() {
    return {
      type: false,

      currentTab: 0,
      tabs: ["계좌/현금/직불카드", "인터넷"],
      selectedAcno: "",
      selectedAcnoDetail: "",
      info: {
        acno: "", //계좌번호
        alias: "", //별칭
        acnDsticCd: "", //계좌종류
        ovsesCustOcntryName: "",
      },
      //인터넷이용정지
      infoValue: {},
      acno: "", //계좌번호
      acnAls: "", //계좌별칭
      acnCustOcntryName: "", //예금주
      acidntRprtRegiStusDstcd: "", //순서 사고신고등록상태구분코드
      cardNo: "", //카드번호
      brncoElctrFinacTranPtrnDstcd: "", //전자금융거래유형구분코드
      acidntRprtYmd: "", //신고일자
      chnlDstcd: "", //채널구분코드
      userIdnfr: "", //사용자식별자
      rprtrCntpTelno: "", //신고자연락처전화번호
      acidntRprtCustOcntryName: "", //사고신고고객자국명
      resultView: false,
      RBF0409S40: {
        requestData: {},
        responseData: { outItem: undefined },
      },

      ondmdTrnhis: {},

      RBF0409S40Response: {
        totalCnt: 0,
        dataGrid: [],
      },
    };
  },
  created() {
    this.page = "";
    this.page = Number(this.page);
    this.RBF0409S40Call();
  },
  mounted() {},
  methods: {
    ...mapActions(["actSetError"]),
    acnoChange(data) {
      // this.$log.info("22222========>", data);
      this.$set(this.info, "acno", data.acno); //계좌정보 저장.
      this.$set(this.info, "alias", data.alias); //계좌정보 저장.
      this.$set(this.info, "ovsesCustOcntryName", data.ovsesCustOcntryName);
      // this.$set(this.incaKepad, "acno0", data.acno);

      // this.$refs.brncoEcrypPwd.init();
    },
    goNext() {
      this.acnoInfo = this.info;
      this.$router.push({ name: "reportsInquiryStep2" });
    },

    RBF0409S40Call() {
      if (this.page == "") {
        this.page = 1;
      } else {
        this.page++;
      }

      this.RBF0409S40.requestData = {
        inquryAcnCustOcntryName: "",
        inquryPrcCd: "1", //0 : 계좌, 1 : 인터넷
        inquryAcnAls: "", //계좌별칭
        inquryAcno: "", //계좌번호
        pageLineCnt: "10",
        dmndPageNo: String(this.page),
      };
      // this.$log.info("page========>" + this.page);
      this.$post("/customer/acidnt/AcidntRprtHist1", this.RBF0409S40.requestData, this.RBF0409S40Suc, this.RBF0409S40Fail, this.RBF0409S40Final);
    },
    /* API_RBF0407G40 통신 성공 */
    RBF0409S40Suc(res) {
      if (res.outItem.ErrmsgErrcd) {
        this.actSetError({
          active: true,
          errCode: res.outItem.ErrmsgErrcd,
          errMsg: res.outItem.ErrmsgOutptCstzMsgCtnt,
        });
      } else {
        this.resultView = true;
        this.RBF0409S40.responseData.outItem = res.outItem;
        this.ondmdTrnhis = {
          ...res.outItem,
        };

        this.RBF0409S40Response.totalCnt = res.outItem.totalLineCnt;

        if (this.RBF0409S40Response.totalCnt > 0) {
          if (this.page === 1) {
            // this.$log.info("res page 111========>" + this.page);
            this.RBF0409S40Response.dataGrid = [...res.outItem.rprtListGrid];
          } else {
            // this.$log.info("res page other========>" + this.page);
            this.RBF0409S40Response.dataGrid = [...this.RBF0409S40Response.dataGrid, ...res.outItem.rprtListGrid];
          }
          this.$refs.commonGrid.changeList(this.RBF0409S40Response.dataGrid);
        }

        // this.$log.info("res========>", res);
      }
    },
    /* API_RBF0407G40 통신 실패 */
    RBF0409S40Fail() {},
    /* API_RBF0407G40 통신 마지막 */
    RBF0409S40Final() {},
    scrollEvent() {
      // if (this.approvalSearch.page * 10 < this.GL5040101Response.totalCnt) {
      //   this.RBF0409S40Call();
      // }

      // if (this.RBF0409S40Response.dataGrid.length < 10 && this.RBF0409S40Response.totalCnt != 0) {
      //   return;
      // } else if (this.page * this.RBF0409S40Response.dataGrid.length == this.RBF0409S40Response.totalCnt) {
      //   return;
      // } else {
      //   //this.RBF0404I40Call();
      //   this.RBF0409S40Call();
      // }

      if (this.page * 10 < this.RBF0409S40Response.totalCnt) {
        this.RBF0409S40Call();
      }
      // this.$log.info("scrollEvent page ========>" + this.page * this.RBF0409S40Response.dataGrid.length);
    },
    modalOpen() {
      this.type = true;
    },
  },
};
</script>
